import api, { nonAuthApi } from './apiHelper';

export const postChangePassword = ({ currentPassword, newPassword }) => api.post('/auth/change-password', { currentPassword, newPassword });

export const postLogin = (username, password) => nonAuthApi.post('/auth/login', { username, password });

export const postRegister = payload => nonAuthApi.post('/auth/register', payload);

export const postVerify = () => api.post('/auth/verify');
